module.exports = __webpack_public_path__ + "static/banner-icon-1-6-0de6ddc0c0bb50bda0b3e0348e02891f.svg";